module.exports = __webpack_public_path__ + "static/media/bshare.2f739dbf.svg";